import { createContext } from 'react'
import { RootState } from 'typesafe-actions'

type TTyylit = RootState['tyylit']

const TyylitContext = createContext<TTyylit>(new Map())

export default TyylitContext
